(ns bp-libs.design-system.components.error-instruction
  "Namespace for error instruction steps")

(defn error-detail
  "Component that displays a configurable Modal"
  {:storybook {:error-name {:name         "Error name"
                            :control      {:type "text"}
                            :defaultValue "Problema ao reproduzir a mídia"}
               :error-instruction-title {:name         "Error instruction title"
                                         :control {:type "text"}
                                         :defaultValue "Reinicie o aparelho"}
               :error-code {:name         "Error code"
                            :control      {:type "text"}
                            :defaultValue "6002"}
               :steps {:name         "Steps"
                       :control {:type "array"}
                       :defaultValue ["1. Desligue o aparelho da tomada"
                                      "2. Pressione o botao ligar por 2 segundos"]}}}
  [{:keys [error-name error-instruction-title steps error-code]}]
  [:div {:class ["bg-surface-primary-3 text-white"
                 "h-full grow"
                 "px-28"
                 "flex flex-col"]
         :style {:max-width "65%"}}
   [:div {:class ["flex flex-col flex-grow"]}
    [:p {:class ["text-4xl font-bold"
                 "py-8"]} error-name]
    [:p {:class ["text-5xl font-bold"
                 "mb-12"]} error-instruction-title]
    [:div {:class ["space-y-8"]}
     (for [step steps]
       ^{:key (hash step)}
       [:p {:class ["text-3xl text-white font-normal"]} step])]]
   [:p {:class ["text-base font-normal"
                "pb-20"]}
    (str "Código de erro: " error-code)]])
